import { c as _c } from "react/compiler-runtime";
import { useDeepLink } from '@/hooks/useDeepLink';
import { useMemo } from 'react';
export function useInteractionDeeplink() {
  const $ = _c(4);
  const {
    deepLinkInteractionId,
    setDeepLinkInteractionId
  } = useDeepLink();
  const t0 = !!deepLinkInteractionId;
  let t1;
  if ($[0] !== deepLinkInteractionId || $[1] !== setDeepLinkInteractionId || $[2] !== t0) {
    t1 = {
      deepLinkInteractionId,
      isInteractionDeeplink: t0,
      setDeepLinkInteractionId
    };
    $[0] = deepLinkInteractionId;
    $[1] = setDeepLinkInteractionId;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}